import React from 'react';
import './CustomAlert.css';

const CustomAlert = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="custom-alert-overlay">
      <div className="custom-alert-box">
        <p>{message}</p>
        <button onClick={onClose} className="custom-alert-button">
          Close
        </button>
      </div>
    </div>
  );
};

export default CustomAlert;
